import {
  CubeReducerState,
  CubeStatus,
  VisibleEnabledFeatureAvailable
} from 'modules/Cube/domain/cube.domain.types'

export const getPreviewQuoteAvailable = (
  prevState: CubeReducerState
): VisibleEnabledFeatureAvailable => {
  return {
    available: {
      visible: [
        CubeStatus.QuoteDraft,
        CubeStatus.QuotePublished,
        CubeStatus.QuoteReadyToSign,
        CubeStatus.QuoteTemplate
      ].includes(prevState.data.common.status),
      enabled: [
        CubeStatus.QuoteDraft,
        CubeStatus.QuotePublished,
        CubeStatus.QuoteReadyToSign,
        CubeStatus.QuoteTemplate
      ].includes(prevState.data.common.status)
    },
    reasons: []
  }
}
